export type AssetType = {
  id: string;
  name: string;
  is_enabled: boolean;
}

export type Asset = {
  asset_id: string;
  asset_name: string;
  asset_type: AssetType
  owner: {
    id: string;
    name: string;
    is_enabled: boolean;
  };
  description: string;
  status_assignment: null | {
    set_at_timestamp: string;
    clear_at_timestamp: string | null;
    asset_status: null | {
      description: string;
      asset_status_id: string;
    };
    set_by: null | {
      name: string;
    };
  };
  location: {
    venue: {
      id: string;
      name: string;
    };
    region: {
      id: string;
      name: string;
    };
    coordinates: {
      latitude: number;
      longitude: number;
    };
    uncertainty: number;
    is_outdoors: boolean;
    building_level: {
      possible_buildings: [
        {
          id: string;
          name: string;
        },
      ];
      level: {
        id: string;
        name: string;
        short_name: string;
      };
    };
  };
  assigned_beacon: null | {
    id: string;
    beacon_type: string;
    battery: number;
    import_info: {
      import_timestamp: string;
      source: null | string;
      order_id: string;
    };
  };
  mobility_state: string;
  last_update_timestamp: string;
  last_location_update_timestamp: string;
  creation_timestamp: string;
};

export type AssetListResponse = {
  items: Asset[]
  next: string
  total: number
}

export type AssetActivity = {
  clear_at_timestamp: string | null;
  set_at_timestamp: string | null;
  asset_status: null | {
    description: string;
  };
  set_by: null | {
    name: string;
  };
};

export type AssetActivitiesResponse = {
  items: AssetActivity[]
  total: number
  count: number
}

export type AssetStatus = {
  asset_status_id: string;
  description: string;
};

export type ClearPeriod = {
  minutes: number
}

export type AssetData = {
  asset_id: string,
  asset_name: string,
  asset_type_id: string,
  owner_id: string,
  description: string,
  assigned_beacon_id: string | null,
}

export class AssetDto {
  data: AssetData = {
    asset_id: "",
    asset_name: "",
    asset_type_id: "",
    owner_id: "",
    description: "",
    assigned_beacon_id: null
  }
  revision: number = 0
}

export enum DownloadStatusEnum {
  'processing' = 'processing',
  'export_succeeded' = 'export_succeeded',
  'failed' = 'failed',
}

export type DownloadJobStatusResponse = {
  status: DownloadStatusEnum
  url: string
}